<template>
    <div>
        <!-- 关联请求 -->
        <el-table :data="tableData">
            <el-table-column label="编号" prop="serialNumber"></el-table-column>
            <el-table-column label="标题" prop="title"></el-table-column>
            <el-table-column label="部门" prop="category"></el-table-column>
            <el-table-column label="请求分类" prop="serialNumber"></el-table-column>
            <el-table-column label="报告人" prop="title"></el-table-column>
            <el-table-column label="指派人" prop="category"></el-table-column>
            <el-table-column label="创建时间" prop="category"></el-table-column>
        </el-table>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                tableData:[]
            }
        },
        created() {

        },
        methods: {}
    }
</script>

<style lang="scss" scoped rel="stylesheet/scss">

</style>